<template>
	<!-- 底部 -->
	<div class="footer">
		<!-- 合作伙伴 -->
		<div class="hzhb">
			<h2>成为我们的合作伙伴</h2>
			<span></span>
			<ul class="box">
				<li>1.注册认证</li>
				<li><img src="../../static/images/dian.png" alt="widthFix"></li>
				<li>2.登录入驻</li>
				<li><img src="../../static/images/dian.png" alt="widthFix"></li>
				<li>3.平台使用</li>
			</ul>
			<button @click='mfrz'>免费入驻</button>
		</div>
		<!-- 底部链接 -->
		<div class="bottom">
			<div class="box">
				<div class="lt">
					<dl v-for="(item,idx) in bottomList" :key='idx'>
						<dt>{{item.tit}}</dt>
						<dd v-for="(item1,idx1) in item.text" :key="idx1"><a href="###" :title="item1">{{item1}}</a></dd>
					</dl>
				</div>
				<div class="rt">
					<dl>
						<dd>
							<p title="关注平台移动门户">关注平台移动门户</p>
							<img src="../../src/assets/service.jpg">
						</dd>
					</dl>
				</div>
			</div>
		</div>
		<div class="trademark">
			<p>Copyright&nbsp;©&nbsp;2019&nbsp;minicute 杭州鑫龍云网络科技有限公司&nbsp;版权所有&nbsp;&nbsp;浙ICP备18045824号</p>
			<img src="../../static/images/icon_police1.png" alt="">
			<img src="../../static/images/icon_police2.gif" alt="">
			<span>浙公网安备 33010802010295号</span>
		</div>
		<maintai :isMfrz='isMfrz' @close='close'></maintai>
	</div>
</template>
<script>
	import maintai from './maintain.vue'

	export default {
		components:{
			maintai
		},
		data () {
			return {
			  isMfrz:false,						//免费入驻弹框
			  bottomList:[
				  {
					  tit:"新手入门",
					  text:["新手指南","热门FAQ","热门FAQ","平台规则"]
				  },
				  {
					  tit:"服务支持",
					  text:["开发文档","业务文档","物料模版下载","鑫龍云开放日"]
				  },
				  {
					  tit:"客服帮助",
					  text:["技术支持中心"]
				  },
				  {
					  tit:"合作洽谈",
					  text:["点此与我联系"]
				  }
			  ]

			}
		},
		methods:{
			//打开免费入驻弹框
			mfrz(){
				this.isMfrz = true
			},
			//关闭免费入驻弹框
			close(){
				this.isMfrz = false
			}
		}
	}
</script>

<style scoped>
/* 合作伙伴 */
.hzhb{background-image: url(../../static/images/dibu_bg.png);background-repeat: no-repeat;width: 100%;height: 7rem;background-size: 100% 100%;text-align: center;color: #FFFFFF;padding-top: 1rem;}
.hzhb h2{font-size: .48rem;letter-spacing: .2rem;margin-left: .2rem;}
.hzhb span{display: block;width: 1.17rem;height: .06rem;background-color: #FFFFFF;box-shadow:0rem .08rem .11rem .01rem rgba(110,110,110,0.47);margin: .33rem auto;}
.hzhb .box{display: flex;justify-content: space-between;margin-top: 1.19rem;}
.hzhb .box li{font-size: .3rem;letter-spacing: .1rem;margin-left: .1rem;}
.hzhb .box li img{width:1.64rem;}
.hzhb button{width:4.2rem;height:1rem;background:rgba(76,134,252,1);border-radius:.1rem;font-size: .36rem;color: #FFFFFF;margin-top: 1.37rem;letter-spacing: .1rem;padding-left: .1rem;}

/* 底部链接 */
.bottom{width: 100%;background-color: #232940;padding: .56rem 0 .34rem;color: #FFFFFF;overflow: hidden;}
.bottom .lt{overflow: hidden;width: 10.24rem;float: left;}
.bottom .lt dl{float: left;width:2.56rem ;}

.bottom dt{font-size: .26rem;line-height: .46rem;margin-bottom: .64rem;}
.bottom dd a{margin-top: .52rem;color: #CECECE;font-size: .18rem;display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.bottom .rt{float: left;height: 4.5rem;border-left: .01rem solid #8B8B8B;padding-left:.52rem;text-align: center;width: 2.5rem;}
.bottom .rt dd img{width: 1.7rem;margin: .32rem 0 .22rem 0;}
.bottom .rt dd p{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.bottom .lt dl dd a:hover{color: #108ee9;}

.trademark{background-color:#232940 ;text-align: center;font-size: .12rem;color:#F3F0F0;font-family:Adobe Heiti Std R;padding: .2rem;}
.trademark p{line-height: .3rem;}
.trademark img {width: 20px;height: 20px;margin-right: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue